import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { AppConfig } from "../config/config";
import { catchError, Observable, throwError } from "rxjs";
import { PaginationDto, ResponsePackage } from "shared-lib";
import { CustomerCrudTable } from "../models/customer.model";

@Injectable({
  providedIn: 'root',
})
export class CustomerService {
  private pathApi: string;
  constructor(private http: HttpClient, private config: AppConfig) {
    this.pathApi = this.config.setting['pathApi'] + 'customer/';
  }

  private headers = new HttpHeaders({ 'Content-Type': 'application/json' });

  getAllCrud(obj: any) {
    return this.http.post<ResponsePackage<PaginationDto<CustomerCrudTable>>>(
      `${this.pathApi}getAllCrud`,
      obj,
      { headers: this.headers, observe: 'response' }
    );
  }

  getCrud(id: number) {
    return this.http.get<ResponsePackage<any>>(
      `${this.pathApi}getCrud?id=${id}`,
      { headers: this.headers, observe: 'response' }
    );
  }

  getSltStatusesForOptions(utilityId: number | null = null): Observable<any> {
    let url = `${this.pathApi}getSltStatusesForOptions`;

    if (utilityId !== null) {
      url += `?utilityId=${utilityId}`;
    }

    return this.http.get(url, { observe: 'response' });
  }

  downloadCrud(obj: any): Observable<any> {
    return this.http.post(`${this.pathApi}downloadFileCrud`, obj, {
      headers: this.headers,
      observe: 'response',
    });
  }

  get(id: number) {
    return this.http
      .get<ResponsePackage<any>>(`${this.pathApi}${id}`, {
        headers: this.headers,
        observe: 'response',
      })
      .pipe(
        catchError((error) => {
          console.error('HTTP request error:', error);
          return throwError(() => new Error('HTTP request error'));
        })
      );
  }

  recallDataQuality(id: number) {
    return this.http.get<ResponsePackage<any>>(
      `${this.pathApi}recallDataQuality/${id}`,
      { headers: this.headers, observe: 'response' }
    );
  }

  auditCustomer(obj: any): Observable<any> {
    return this.http.post(`${this.pathApi}auditCustomer`, obj, {
      headers: this.headers,
      observe: 'response',
    });
  }

  delete(id: number): Observable<any> {
    return this.http.delete(`${this.pathApi}delete/${id}`, {
      observe: 'response',
    });
  }


  reviewCustomer(obj: any): Observable<any> {
    return this.http.post(`${this.pathApi}reviewCustomer`, obj, {
      headers: this.headers,
      observe: 'response',
    });
  }

  addCustomer(obj: any) {
    return this.http.post<ResponsePackage<string>>(`${this.pathApi}save`, obj, {
      headers: this.headers,
      observe: 'response',
    });
  }

  getCustomerDataQuality(id: number): Observable<any> {
    return this.http.get(`${this.pathApi}getCustomerDataQuality/${id}`, {
      observe: 'response',
    });
  }

  rejectCustomer(obj: any): Observable<any> {
    return this.http.post(`${this.pathApi}rejectCustomer`, obj, {
      headers: this.headers,
      observe: 'response',
    });
  }

  getPermises(): Observable<any> {
    return this.http.get(`${this.pathApi}getPermises`, {
      observe: 'response',
    });
  }

  getActivities(): Observable<any> {
    return this.http.get(`${this.pathApi}getActivities`, {
      observe: 'response',
    });
  }
}
